import React from 'react';
import SpinnerLoaderComponent from 'src/components/common/loader/SpinnerLoader';

/**
 * Interface defining the props for the ReportGenerationProgress component
 */
interface ReportGenerationProgressProps {
    /**
     * Message to display in the progress indicator
     */
    progressMessage: string;
}

/**
 * Component that displays a loading spinner with progress information during report generation
 */
const ReportGenerationProgress: React.FC<ReportGenerationProgressProps> = ({ progressMessage }) => {
    return <SpinnerLoaderComponent isGlobalOverlay message={progressMessage} clearDefaultText />;
};

export default ReportGenerationProgress;
